import { render, staticRenderFns } from "./ServerStatus.vue?vue&type=template&id=836ca9fe&scoped=true&"
import script from "./ServerStatus.vue?vue&type=script&lang=js&"
export * from "./ServerStatus.vue?vue&type=script&lang=js&"
import style0 from "./ServerStatus.vue?vue&type=style&index=0&id=836ca9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836ca9fe",
  null
  
)

export default component.exports